import { SCHEMES, TOOLTIP_OPTIONS } from '@/components/EchartCustomized'
import Echart from '@/components/EchartCustomized/MapEchart'
import { formatVolumeUnit } from '@/utils/function'
import React from 'react'
import { Typogaphy } from 'vnetwork-ui'
import { Viewers } from '../../types'
import countries from './countries.json'

interface LocationViewerProps {
    viewers: Viewers
}
const LocationViewer: React.FC<LocationViewerProps> = ({ viewers = [] }) => {
    const data = viewers?.map((item: any) => {
        const country = countries?.find(
            (option) => option.value === item.country?.toLowerCase()
        )

        const result = {
            value: item.volume / 1000 ** 3,
            name: country?.label,
        }

        return result
    })

    // visualMap range in GB. min is 0 (not a hardcoded 10) and max is clamped to a
    // positive value: geo volumes can be tiny (< 1 GB on low-traffic/staging), and a
    // min > max range makes echarts build a NaN gradient → addColorStop(undefined)
    // crash. Guarding both bounds keeps the map rendering for empty/tiny data too.
    const values = (data?.map((item: any) => item.value) || []).filter(
        (v: number) => Number.isFinite(v)
    )
    const maxVolume = values.length ? Math.max(...values) : 0
    const minVolume = 0

    const options = {
        height: 750,
        tooltip: {
            trigger: 'item',
            ...TOOLTIP_OPTIONS,
            formatter: function (params: any) {
                return (
                    params.value &&
                    `<b>${params.name}</b><br/>Volume: ${formatVolumeUnit(params.value * 1000 ** 3)}`
                )
            },
        },
        // title: {
        //   text: 'Global Viewers Location (by volume)',
        //   subtext: 'Last 30 days',
        //   left: 'right'
        // },
        visualMap: {
            left: 'right',
            min: minVolume,
            max: maxVolume > minVolume ? maxVolume : minVolume + 1,
            inRange: {
                color: Array.from(SCHEMES.mono.navy)?.reverse(),
            },
            text: ['High', 'Low'],
            calculable: true,
            formatter: function (value: number) {
                return formatVolumeUnit(value * 1000 ** 3)
            },
        },
        series: [
            {
                name: 'Location Traffic',
                type: 'map',
                map: 'World',
                // roam: true,
                // silent: true,
                emphasis: {
                    label: {
                        show: false,
                    },
                },
                data: data,
            },
        ],
    }

    return (
        <div className="bg-white rounded-[8px] p-4">
            <div className="">
                <Typogaphy size="medium" className="text-primary font-semibold">
                    Traffic by Location
                </Typogaphy>
            </div>
            {/* @ts-ignore */}
            <Echart options={options} height={500} width={500} />
        </div>
    )
}

export default LocationViewer
